import React, { ReactNode } from 'react';
import { useUserContext } from '../../contexts';
import AccountUpgradeFlow from './AccountUpgradeFlow';

export default function UpgradeFlowProvider({ children }: { children: ReactNode }) {
  const { user, isLoggedIn } = useUserContext();
  if (!isLoggedIn || !user) return <>{children}</>;

  return (
    <AccountUpgradeFlow key={user.id} user={user}>
      {children}
    </AccountUpgradeFlow>
  );
}
